import { ChevronDown } from "react-feather";
import styled, { css } from "styled-components";
import { COLOR_BLACK, COLOR_RED, COLOR_WHITE } from "../constants/colors";
import { Body1, Body2, Subtitle2 } from "./Typography";

type InputProps = {
  label: string;
  value: string;
  placeholder: string;
  items: { label: string; value: string }[];
  error?: string;
  onChange: (value: string) => void;
};
const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Label = styled.label`
  ${Body1}
  color: ${COLOR_WHITE};
`;

const StyledSelect = styled.select<{ hasError: boolean }>`
  ${Subtitle2}
  width: 100%;
  color: ${COLOR_BLACK};
  border-radius: 12px;
  padding: 6px 20px;
  border: 2px solid ${COLOR_WHITE};
  outline: none;

  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;

  ${(props) =>
    props.hasError &&
    css`
      border: 2px solid ${COLOR_RED};
      ::placeholder {
        color: ${COLOR_RED};
      }
      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: ${COLOR_RED};
      }
      ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: ${COLOR_RED};
      }
    `}

  @media (max-width: 768px) {
    border-radius: 8px;
    padding: 6px 16px;
  }
`;

const Error = styled.div`
  ${Body2}
  color: ${COLOR_WHITE};
`;

const IcChevronDown = styled(ChevronDown)`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${COLOR_BLACK};
  @media (max-width: 768px) {
    width: 12px;
    height: 12px;
    right: 4px;
  }
`;

function DropDown(props: InputProps) {
  const { label, value, placeholder, onChange, error, items } = props;

  const onInputChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <InputWrapper>
      <Label className="mb-2">{label}</Label>
      <div className="position-relative">
        <StyledSelect hasError={!!error} value={value} placeholder={placeholder} onChange={onInputChanged}>
          {items.map((item) => (
            <option value={item.value} key={item.value}>
              {item.label}
            </option>
          ))}
        </StyledSelect>
        <IcChevronDown />
      </div>
      {error && <Error className="mt-1">{error}</Error>}
    </InputWrapper>
  );
}

export default DropDown;

DropDown.defaultProps = {
  error: "",
};
